import t from '@/store/types';
import { createReducer } from '@reduxjs/toolkit';

// « Tout » par défaut : la recherche rapide cherche sur toutes les ressources
// ET les fonctionnalités/pages tant que l'utilisateur ne restreint pas le type.
const DEFAULT_RESOURCE_TYPE = 'all';

const initialState = {
  isOpen: false,
  defaultResourceType: DEFAULT_RESOURCE_TYPE,
  selectedItem: {},
};

export default createReducer(initialState, (builder) => {
  builder.addCase(t.OPEN_SEARCH, (state, action) => {
    state.isOpen = true;
  });

  builder.addCase(t.CLOSE_SEARCH, (state, action) => {
    state.isOpen = false;
  });

  builder.addCase(
    t.UNIVERSAL_SEARCH_SET_RESOURCE_TYPE,
    (state, action: any) => {
      state.defaultResourceType = action.payload.resourceType;
    },
  );

  builder.addCase(t.UNIVERSAL_SEARCH_RESET_RESOURCE_TYPE, (state, action) => {
    state.defaultResourceType = DEFAULT_RESOURCE_TYPE;
  });

  builder.addCase(t.UNIVERSAL_SEARCH_SET_ITEM_SELECT, (state, action: any) => {
    state.selectedItem = {
      resourceId: action.payload.resourceId,
      resourceType: action.payload.resourceType,
    };
  });

  builder.addCase(t.UNIVERSAL_SEARCH_RESET_ITEM_SELECT, (state, action) => {
    state.selectedItem = {};
  });
});
